<form #searchForm="ngForm" action="" class="container-Search">
  <fieldset class="container">
    <mat-form-field appearance="fill">
      <input [(ngModel)]="searchBranchNameSignal" name="search" placeholder="ค้นหาสาขา" (keyup.enter)="onClickSearchInput()" matInput />
      <mat-icon (click)="onClickSearchInput()" matSuffix class="cursor-pointer">search</mat-icon>
    </mat-form-field>
    <span class="font-size-16 font-weight-medium item-text">หรือ</span>
    <button type="button" mat-flat-button (click)="onClickSearchButton()">ค้นหาสาขาที่ใกล้ฉัน</button>
  </fieldset>
</form>
